import React, { useState } from "react";
import imgdekstop from "../../../images/AdobeStock_638524851.jpg";
import imgdeMobile from "../../../images/AdobeStock_808744720.jpg";
import OtpInput from "./otpInput/OtpInput";
import PhoneInput from "./phoneInput/PhoneInput";
import InputSlider from "./inputSlider/InputSlider";
import { Link } from "react-router-dom";

const LoginModal = ({ setIsVisible, slideGoDOwn, bookPage, setBookPage }) => {
  return (
    <>
      <section className={`bodylogin`}>
        <div
          className="login-slide-up z-[50] "
          onClick={() => setIsVisible(false)}
        >
          <div
            className="bottom-touch-wrapper"
            onClick={(e) => e.stopPropagation()}
          >
            {/* <div className="close-btn-div">
              <div
                className="close-btn-wrapper cursor-pointer"
                onClick={() => {
                  
                  setIsVisible(false);
                }}
              >
                <div
                  className="w-embed"
                 
                >
                 

                  <svg
                    width="100%"
                    height="100%"
                    version="1.1"
                    id="Layer_1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    x="0px"
                    y="0px"
                    viewBox="0 0 122.881 122.88"
                    enableBackground="new 0 0 122.881 122.88"
                    xmlSpace="preserve"
                  >
                    <g>
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        fill="#fff"
                        d="M61.44,0c33.933,0,61.441,27.507,61.441,61.439 c0,33.933-27.508,61.44-61.441,61.44C27.508,122.88,0,95.372,0,61.439C0,27.507,27.508,0,61.44,0L61.44,0z M81.719,36.226 c1.363-1.363,3.572-1.363,4.936,0c1.363,1.363,1.363,3.573,0,4.936L66.375,61.439l20.279,20.278c1.363,1.363,1.363,3.573,0,4.937 c-1.363,1.362-3.572,1.362-4.936,0L61.44,66.376L41.162,86.654c-1.362,1.362-3.573,1.362-4.936,0c-1.363-1.363-1.363-3.573,0-4.937 l20.278-20.278L36.226,41.162c-1.363-1.363-1.363-3.573,0-4.936c1.363-1.363,3.573-1.363,4.936,0L61.44,56.504L81.719,36.226 L81.719,36.226z"
                      />
                    </g>
                  </svg>
                </div>
              </div>
            </div> */}
            <div className="w-layout-grid login-page-grid">
              <div id="" className="login-page-grid-left">
                <img
                  src={imgdekstop}
                  loading="lazy"
                  alt=""
                  className="login-image-desktop w-full"
                />
              </div>
              <div
                id="w-node-_2be679b0-fc25-0cca-4da2-d6f34bfefdaa-749844cf"
                className="login-page-grid-right"
              >
                {/* {getOtpClicked ? (
                  <OtpInput />
                ) : (
                  <PhoneInput setGetOtpCliked={setGetOtpCliked} />
                )} */}

                <InputSlider
                  setIsVisible={setIsVisible}
                  setBookPage={setBookPage}
                  bookPage={bookPage}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default LoginModal;
